<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('attribute.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="attribute.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('attribute.form.fields.status.label')"
            label-for="input-status"
            :description="$t('attribute.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="attribute.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('attribute.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import AttributeRepository from '@/repositories/vns/AttributeRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      attribute_id: null
    }
  },
  computed: {
    ...mapGetters({
      attribute: 'attribute/current',
      isLoading: 'attribute/isLoading'
    }),
    pageTitle() {
      if (this.attribute_id) return this.$t('attribute.form.titulo_pagina.editar')
      return this.$t('attribute.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'attribute/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      AttributeRepository.post(this.attribute).then(() => {
        this.$snotify.success(this.$t('attribute.form.create.success'))
        this.$router.push({name: 'vns.attribute'})
      }).catch(error => {
        this.$snotify.error(this.$t('attribute.form.create.error'))
        if (error.response.status === 422) {
          AttributeRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      AttributeRepository.put(this.attribute_id, this.attribute).then(() => {
        this.$snotify.success(this.$t('attribute.form.update.success'))
        this.$router.push({name: 'vns.attribute'})
      }).catch(error => {
        this.$snotify.error(this.$t('attribute.form.update.error'))
        if (error.response.status === 422) {
          AttributeRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('attribute/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.attribute_id = this.$route.params.id
      await this['attribute/listOne'](this.$route.params.id)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
